import ErrorHandler from "@zendesk/knowledge-utils/lib/ErrorHandler";

const errorHandler = new ErrorHandler();

const notifyError = (component, error) => {
  errorHandler.notify({
    error,
    context: {
      version: process.env.VERSION,
      component: `verification:${component}`,
      details: error.details,
    },
  });

  console.error(component, error);
};

export default notifyError;



// WEBPACK FOOTER //
// ./src/utils/notifyError.js